import React from 'react'

const JobOffersIcon: React.FC = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
		<path
			className="stroke-current"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="2"
			d="M19 12.255A23.931 23.931 0 0110 14c-3.183 0-6.22-.62-9-1.745M14 5V3a2 2 0 00-2-2H8a2 2 0 00-2 2v2m4 6h.01M3 19h14a2 2 0 002-2V7a2 2 0 00-2-2H3a2 2 0 00-2 2v10a2 2 0 002 2z"
		></path>
	</svg>
)

export default JobOffersIcon
